import { gql } from '@apollo/client'

export const Query = gql`
  query Vehicles($companyId: ID!, $filters: VehicleFilters, $order: VehicleOrder, $after: String, $before: String, $first: Int, $last: Int) {
    vehicles(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        registration
        warehouse {
          id
          name
        }
        rateCents
        mileageCents
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
